import axios from "@/libs/api.request";
// 获取列表
export const getList = params => {
  return axios.request({
    url: "/finance/StorageBill/index",
    method: "get",
    params
  });
};

export const detail = params => {
  return axios.request({
    url: "/finance/StorageBill/detail/"+params.id,
    method: "get",
    params
  });
};

export const update = data => {
  return axios.request({
    url: "/finance/StorageBill/update/"+data.id,
    method: "post",
    data
  });
};

export const del = data => {
  return axios.request({
    url: "/finance/StorageBill/delete/"+data.id,
    method: "post",
    data
  });
};

export const confirm = data => {
  return axios.request({
    url: "/finance/StorageBill/confirm/"+data.id,
    method: "post",
    data
  });
};

export const writeOff = data => {
  return axios.request({
    url: "/finance/StorageBill/write_off/"+data.id,
    method: "post",
    data
  });
};

export const exportData = id => {
  return axios.request({
    url: "/finance/StorageBill/export/"+id,
    method: "post",
  });
};